module.exports = __webpack_public_path__ + "img/industrias_de_nutraceuticos.c6cf88f5.png";